module.exports = __webpack_public_path__ + "prod/20260811181522/img/service.edbff227.png";